// extracted by mini-css-extract-plugin
module.exports = {"contentButtons":"botonsPrevisio_contentButtons__bMusK","boto":"botonsPrevisio_boto__JtE4g","selected":"botonsPrevisio_selected__sgyeA"};